import React from 'react';

interface CardProps {
  title?:    string;
  children:  React.ReactNode;
  className?: string;
}

/** Tarjeta de sección con título opcional. */
export const Card: React.FC<CardProps> = ({ title, children, className = '' }) => (
  <div className={`overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-gray-100 ${className}`}>
    {title && (
      <div className="border-b border-gray-100 bg-gray-50 px-5 py-3">
        <h3 className="text-xs font-semibold uppercase tracking-widest text-gray-400">{title}</h3>
      </div>
    )}
    <div className="px-5 py-4">{children}</div>
  </div>
);
